

export const OSP_HOME_URL = 'https://opensyllabus.org';
export const MIN_TOP_VISIBLE = 5000;
export const BOTTOM_QUERY_SIZE = 500;
